import { Injectable, inject } from '@angular/core';

import {
  Identifier as IdentifierResponse,
  IdentifierInput,
  TransactionIdsByIdentifiersInput,
  TransactionIdsByIdentifiersResponse,
} from 'projects/semeris/src/generated/graphql-models';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { Transaction } from '../../home/models/transaction.model';
import {
  GET_IDENTIFIERS,
  GET_TRANSACTION_IDS_BY_IDENTIFIERS,
} from '../../shared/constants/gql-queries';
import { GraphQLService } from '../../shared/services/graphql.service';
import { IdentifierSearchResult } from '../models/identifier-search-result.model';
import { Identifier } from '../models/identifier.model';

@Injectable({ providedIn: 'root' })
export class IdentifierService {
  private readonly graphQlService = inject(GraphQLService);

  public getByTransaction(transaction: Transaction): Observable<Identifier[]> {
    return this.graphQlService
      .getManyQuery<IdentifierResponse, { input: IdentifierInput }>(GET_IDENTIFIERS, {
        input: {
          libraryTransactionId: transaction.transactionId,
        },
      })
      .pipe(map((res) => res?.map((r) => this.createViewModel(r)) || []));
  }

  public getByIdentifier(identifier: string): Observable<Identifier[]> {
    return this.graphQlService
      .getManyQuery<IdentifierResponse, { input: IdentifierInput }>(GET_IDENTIFIERS, {
        input: { identifier },
      })
      .pipe(map((res) => res?.map((r) => this.createViewModel(r)) || []));
  }

  public searchByIdentifiers(identifiers: string[]): Observable<IdentifierSearchResult> {
    return this.graphQlService.getSingleQuery<
      TransactionIdsByIdentifiersResponse,
      { input: TransactionIdsByIdentifiersInput }
    >(GET_TRANSACTION_IDS_BY_IDENTIFIERS, {
      input: { identifiers },
    });
  }

  public createViewModel(r: IdentifierResponse): Identifier {
    return {
      figi: r.figi,
      idType: r.idType,
      identifier: r.identifier,
      libraryShortName: r.libraryShortName,
      transactionShortName: r.transactionShortName,
    };
  }
}
